import { render, staticRenderFns } from "./TargetGroups.vue?vue&type=template&id=4ba650df"
import script from "./TargetGroups.vue?vue&type=script&lang=js"
export * from "./TargetGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports